/** @jsxImportSource @emotion/react */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { fetchApplicantStatusOptions } from 'helpers';
import Sidebar from 'components/layout/Sidebar/Sidebar';
import {
  FilterField, FilterActions, countActiveFilters,
} from 'components/layout/Sidebar/Filter';
import { unsectionedFieldsStyles } from 'components/layout/Sidebar/Sidebar.styles';
import {
  CustomDatepicker as Datepicker,
  Select2,
  Select,
} from 'components/common';
import testResultOptions from 'constants/testResultOptions';

import {
  filterConditionsContainerStyles,
  datepickerContainerStyles,
  select2ContainerStyles,
  selectContainerStyles,
} from './Sidebar.styles';

const FTPSidebar = ({
  search,
  startDate,
  endDate,
  setDateRange,
  filterCondition,
  handleChange,
  handleSelect2Change,
  handleSubmit,
  handleReset,
  // handleDownloadCSV,
  // isCsvDownloading,
}) => {
  const [applicantStatusOptions, setApplicantStatusOptions] = useState([]);

  useEffect(() => {
    fetchApplicantStatusOptions()
      .then((data) => {
        setApplicantStatusOptions(data);
      });
  }, []);

  return (
    <Sidebar search={search} activeCount={countActiveFilters(filterCondition, startDate)}>
      <div css={[filterConditionsContainerStyles, unsectionedFieldsStyles]}>
        <FilterField label="test date">
          <Datepicker
            portalId="filter-panel-popover"
            containerStyles={datepickerContainerStyles}
            startDate={startDate}
            endDate={endDate}
            setDateRange={setDateRange}
            placeholder="date range"
          />
        </FilterField>
        <FilterField label="test result">
          <Select
            containerStyles={selectContainerStyles}
            name="testResult"
            options={testResultOptions}
            placeholder="test result"
            value={filterCondition.testResult}
            onChange={handleChange}
          />
        </FilterField>
        <FilterField label="applicant status">
          <Select2
            portalMenu
            containerStyles={select2ContainerStyles}
            defaultValue={{ label: 'applicant status', value: '' }}
            options={applicantStatusOptions}
            placeholder="applicant status"
            onChange={(e) => handleSelect2Change(e, 'applicantStatus')}
            value={filterCondition.applicantStatus}
          />
        </FilterField>
      </div>
      <FilterActions onApply={handleSubmit} onReset={handleReset} />
    </Sidebar>
  );
};

FTPSidebar.propTypes = {
  search: Sidebar.propTypes.search,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  setDateRange: PropTypes.func.isRequired,
  filterCondition: PropTypes.shape({
    applicantStatus: PropTypes.oneOfType(
      [
        PropTypes.string,
        PropTypes.shape({
          label: PropTypes.string,
          value: PropTypes.string,
        }),
      ],
    ),
    testResult: PropTypes.string,
    program: PropTypes.string,
    attendanceStatus: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSelect2Change: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  // handleDownloadCSV: PropTypes.func.isRequired,
  // isCsvDownloading: PropTypes.bool.isRequired,
};

FTPSidebar.defaultProps = {
  search: null,
  startDate: null,
  endDate: null,
};

export default FTPSidebar;
